export default __webpack_public_path__ + "static/media/fireFN8.5ebf6af2.svg";